module.exports = __webpack_public_path__ + "img/22.93707b27.jpg";